<div class="responsive-container p-grid">
  <p-fluid>
  <p-panel>
    <ng-template pTemplate="header">
      <div class="responsive-header">
        <div>
          <span class="responsive-header-title">
            Editar Palet
            <p class="responsive-header-subtitle">Escanear el Código</p>
          </span>
        </div>

        <div class="flex gap-2 align-items-center">
          <button pButton icon="pi pi-times" class="p-button-rounded p-button-text"
          (click)="onClose()"></button>
        </div>
      </div>
    </ng-template>

    <div class="content">
      <!-- View Messages -->
      <p-toast [breakpoints]="{ '920px': { width: '100%', right: '0', left: '0' } }" />

      <div class="field">
        <label for="warehouse">Bodega <span class="req">*</span></label>
        <p-select id="warehouse" optionLabel="name" optionValue="name" [(ngModel)]="selectedWarehouse"
          [options]="warehouses" placeholder="Selecciona una bodega" optionLabel="name"
        [style]="{'width':'100%'}"></p-select>
      </div>

      <!-- Manual Scanner -->
      <div class="field">
        <label for="manualQr">Código de Palet <span class="req">*</span></label>
        <input id="manualCode" type="text" pInputText placeholder="Escanea el Código QR"
          [(ngModel)]="manualQrCode" (input)="onManualInputChange()" />
      </div>

      <!-- Lista de Palets a editar -->
      <div class="field">
        <p-table [value]="scannedPallets" styleClass="p-datatable-sm p-datatable-gridlines p-datatable-striped">
          <ng-template pTemplate="header">
            <tr>
              <th>QR Actualizados</th>
              <th></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-pallet let-i="rowIndex">
            <tr>
              <td>
                {{ pallet.qrCode }}
              </td>
              <td>
                <p-button icon="pi pi-trash" severity="danger" [outlined]="true"
                (click)="removeItem(i)"></p-button>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>

      <!-- Botones de acción -->
      <div class="p-col-12 flex justify-content-between">
        <p-button label="Cancelar" severity="secondary" (click)="onClose()"></p-button>
        <p-button label="Confirmar" (click)="onUpdatePallets()" [disabled]="!scannedPallets.length"></p-button>
      </div>
    </div>
  </p-panel>


  <!-- Dialog to edit pallet -->
  <p-dialog header="Editar Palet" [visible]="showEditDialog" [modal]="true"
    [style]="{width: 'clamp(320px, 92vw, 520px)', 'min-height': '100%'}" [closable]="false" [dismissableMask]="false">
    <div class="content">

      @if (manualQrCode) {
        <div class="field">
          <p-chip [label]="manualQrCode" icon=""><strong>Código:</strong></p-chip>
        </div>
      }

      <form [formGroup]="palletForm">
        <div class="field">
          <label for="pallet_length">Largo <span class="req">*</span></label>
          <p-inputNumber formControlName="depth" id="pallet_length" inputId="minmax" mode="decimal" [min]="1"
            [max]="5000" [fluid]="true" suffix=" cm" placeholder="centimetros" required>
          </p-inputNumber>
          @if (submitted && (formControl['depth'].errors?.['required'] || formControl['depth'].errors?.['whitespace'] || formControl['depth'].errors?.['minlength'])) {
            <small class="p-error"
              >Largo
            es requerido.</small>
          }
        </div>

        <div class="field">
          <label for="pallet_width">Ancho <span class="req">*</span></label>
          <p-inputNumber formControlName="width" id="pallet_width" inputId="minmax" mode="decimal" [min]="1"
            [max]="5000" [fluid]="true" suffix=" cm" placeholder="centimetros" required>
          </p-inputNumber>
          @if (submitted && (formControl['width'].errors?.['required'] || formControl['width'].errors?.['whitespace'] || formControl['width'].errors?.['minlength'])) {
            <small class="p-error"
              >Ancho
            es requerido.</small>
          }
        </div>

        <div class="field">
          <label for="pallet_height">Alto <span class="req">*</span></label>
          <p-inputNumber formControlName="height" id="pallet_height" inputId="minmax" mode="decimal" [min]="1"
            [max]="5000" [fluid]="true" suffix=" cm" placeholder="centimetros" required>
          </p-inputNumber>
          @if (submitted && (formControl['height'].errors?.['required'] || formControl['height'].errors?.['whitespace'] || formControl['height'].errors?.['minlength'])) {
            <small class="p-error"
              >Alto
            es requerido.</small>
          }
        </div>

        <div class="field">
          <label for="adress_notes">Notas</label>
          <textarea formControlName="notes" id="adress_notes" rows="3" cols="30" pInputTextarea
          class="p-inputtext-sm w-full" maxlength="200"></textarea>
        </div>

        <div class="field">
          <label for="flooring">Nivel</label>
          <p-select formControlName="flooring" id="flooring" appendTo="body" [(ngModel)]="flooring"
          [options]="floorings" placeholder="Nivel"></p-select>
        </div>
        <div class="field">
          <label for="location">Locación</label>
          <input formControlName="location" type="text" pInputText id="location" class="w-full"
            placeholder="Locación" />
        </div>

        <!-- Botones de acción -->
        <div class="p-col-12 flex justify-content-between">
          <p-button label="Cancelar" severity="secondary" (click)="onCloseEdit()"></p-button>
          <p-button label="Guardar" (click)="onSavePallet()"
          [disabled]="palletForm.pristine || palletForm.invalid"></p-button>
        </div>

      </form>
    </div>
  </p-dialog>
  </p-fluid>
</div>
<p-confirmDialog></p-confirmDialog>